import React from 'react';
import { useLanguage } from './LanguageProvider';
import planetImg from "../images/planet.svg";

function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();

  const languageMap = {
    'en': 'EN',
    'ua': 'UA',
  };

    const handleChangeLanguage = (newLanguage) => {
        if (newLanguage !== language) {
            setLanguage(newLanguage);
        }
    };

  return (
    <div className="dropdown" style={{zIndex: '50'}}>
      <a className="text-decoration-none switch-text-size card-address">
          <div className="d-flex align-items-center">
              <img
                  style={{ height: '2rem', marginRight: '0.3rem' }}
                  src={planetImg}
                  alt=""
              />
              {languageMap[language]}
          </div>
      </a>
      <ul className="dropdown-menu"
          style={{
              backgroundColor: '#0d0d13',
              minWidth: '3rem',
              bottom: '100% !important',
              top: 'auto !important',
              marginBottom: '.125rem'
          }}
      >
        {Object.keys(languageMap)
            .filter((key) => key !== language)
            .map((key) => (
          <li key={key}>
            <a
              className="text-decoration-none switch-text-size card-address"
              href="#"
              onClick={(e) => {
                  e.preventDefault();
                  handleChangeLanguage(key);
              }}
            >
                <div className="d-flex align-items-center">
                    <img
                        style={{height: '2rem', marginRight: '0.3rem'}}
                        src={planetImg} alt=''/>
                    {languageMap[key]}
                </div>

            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LanguageSwitch;
